import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-ai-latest-collections',
  templateUrl: './ai-latest-collections.component.html',
  styleUrls: ['./ai-latest-collections.component.scss']
})
export class AILatestCollectionsComponent implements OnInit {
  slidesData: any = [];
  latestData:any = [];

  constructor(private dataService: DataService,) { }

  async ngOnInit() {
    (await this.dataService.getLatestBannerService()).subscribe((singleservice) => {
      this.slidesData = [];
      this.slidesData = singleservice;
      //console.log(this.slidesData)
    });
    
    (await this.dataService.getCollectionService()).subscribe(
      (singleservice) => {
        this.latestData = [];

        this.latestData = singleservice.filter((data)=>{
          return data["isFeatured"] && data["isAICollection"]
        })

        //console.log(this.latestData);
      }
    );
  }

}
